const base = {
  // url: 'http://tapi.gym3.com',
  url: 'https://api3t.gymcity.com.cn/',
  // url: 'https://api3.gymcity.com.cn',
  testUrl: '',
  productUrl: '',
  baseUrl: {
    dev: 'https://tbtvue.gymcity.com.cn',
    test: 'https://tbtvue.gymcity.com.cn',
    pre: 'https://betabtvue.gymcity.com.cn',
    pro: 'https://btvue.gymcity.com.cn'
  },
  adminUrlData: {
    dev: 'https://tadmin.betterwestar.com',
    test: 'https://tadmin.betterwestar.com',
    pre: 'https://admin.betterwestar.com',
    pro: 'https://admin.betterwestar.com'
  }, //btnw管理后台
  courseUrlData: {
    dev: 'https://tbtwcourseh5.betterwestar.com',
    test: 'https://tbtwcourseh5.betterwestar.com',
    pre: 'https://btwcourseh5.betterwestar.com',
    pro: 'https://btwcourseh5.betterwestar.com'
  }
}

export default base
